import { useCommonLookup, type CommonLookupResponse } from "newui/store/tanstack-base";
import { getServiceabilityLocationTree } from "../serviceability-api";
import type { CountryLocationGroup } from "../types";

export const useServiceabilityLocationTree = (): CommonLookupResponse<CountryLocationGroup> => {
	return useCommonLookup<CountryLocationGroup>(
		"serviceability-location-tree",
		getServiceabilityLocationTree,
	);
};
